import React, { createContext, useState, useCallback } from 'react';

export const MessageLogContext = createContext({
  messages: [],
  addMessage: () => {},
});

export const MessageLogProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const addMessage = useCallback((text, type = 'info') => {
    const now = new Date().getTime();
    const DUPLICATE_THRESHOLD = 1000; // 1 second

    setMessages(prevMessages => {
      // Check if the same message was added recently (within 1 second)
      const isDuplicate = prevMessages.some(msg => 
        msg.text === text && 
        msg.type === type && 
        (now - msg.timestamp) < DUPLICATE_THRESHOLD
      );

      // If it's a duplicate, don't add it
      if (isDuplicate) {
        return prevMessages;
      }

      // type can be 'info', 'success', 'error', 'warning'
      const newMessage = {
        text,
        type,
        timestamp: now, // For unique key and potential future use
      };
      
      return [...prevMessages.slice(-49), newMessage]; // Keep last 50 messages
    });
  }, []);

  return (
    <MessageLogContext.Provider value={{ messages, addMessage }}>
      {children}
    </MessageLogContext.Provider>
  );
};